export const en = {
  Advies: "Advice",
  BekijkHetAdvies: "Check the advice",
  BestaatUit10DigitsTekst:
    "The field '{{label}}' was not filled in correctly. The field needs to consist of 10 digits.",
  BsnValidationFactoryText:
    "The field '{{label}}' was not filled in correctly. The citizen service number consists of 9 digits.",
  CAKIDnummer: "CAK ID-number",
  CAKIDnummerInfoTxt:
    "This number is on the letter you received from us when you were registered. It consists of 8 digits (start with a 0 if you only have 7 digits). Each family member has its own CAK ID number.",
  ClientGenericError: "An error has occurred",
  ClientTimeoutError: "A timeout has occurred",
  EmailValidationDefaultMessage: `The field '{{label}}' was not filled in correctly, for example: name@domain.nl (replace with your own email address).`,
  HasSpecificLengthyValidationText: `The field '{{label}}' was not filled in correctly. The field requires exactly {{specificAmount}} digits.`,
  MaxLengthMessage: "You entered the maximum number of characters.",
  IkGa90DagenOfKorterOpReis: "I will be traveling 90 days or shorter",
  IkGa91DagenOfLangerOpReis: "I will be traveling for 91 days or more",
  IsDecimalValidationText: "The field '{{label}}' was not filled in correctly. It is not a valid number.",
  IntegerValidationText: "The field '{{label}}' was not filled in correctly. It is not a valid number.",
  EhicFormulier: "Applying for an EHIC",
  UwAanvraagIsVerstuurd: "Your request has been sent.",
  EmailAdres: "Email address",
  EmailAdresControle: "Repeat email address",
  EmailAdresInfoTxt: "We use this e-mail address if we want to contact you about your message.",
  GeboorteDatum: "Date of birth (dd-mm-yyyy)",
  HoeveelDagenGaatUInTotaalOpReis: "How many days will you be traveling in total?",
  IsDecimalValidationFactoryText:
    "The field '{{label}}' was not filled in correctly.. Het mag aleen cijfers bevatten.",
  IsKlantKaartDecimalValidationFactoryText:
    "The field '{{label}}' was not filled in correctly.. Het klantnummer mag maximaal 10 cijfers bevatten.",
  IsIbanValidationFactoryValidationText:
    "The field '{{label}}' was not filled in correctly., example: NL01ABCD0123456789 (replace with your own IBAN).",
  IsPostcodeValidationFactoryValidationText:
    "The field '{{label}}' was not filled in correctly, example: 1234AA (replace with your own postal code).",
  KiesEenLand: "Choose a country",
  Maximaal5BijlagenMaximaal5MBPerBijlage: "Maximaal 5 bijlagen, maximaal 5 MB per bijlage.",
  MedicijnenOpReis: "Medicijnen op reis",
  MedicijnenMeeOpReisHulp: "Medicijnen mee op reis-hulp",
  MedicijnenOpReisTitle: "Heb ik een medicijnverklaring nodig?",
  MeldingNoteerNummerVoorVerzending:
    "Noteer het nummer dat verschijnt na het versturen. Heeft u nog vragen? Geef dan dit nummer door. Zo kunnen wij u beter helpen.",
  MeldingNoteerNummerNaVerzending:
    "Noteer bovenstaand nummer. Heeft u nog vragen? Geef dan dit nummer door. Zo kunnen wij u beter helpen.",
  MinimumBedragInfoTxt:
    "Het minimumbedrag voor een betalingsregeling is € 10 per maand. Kunt u dit niet missen? Neem dan telefonisch contact met ons op.",
  MijnGegevens: "My Details",
  NaarWelkeLandenGaatUOpReis: "Naar welk(e) land(en) gaat u op reis? (maximaal 6 landen)",
  Omschrijving: "Description",
  RepeatEmailAdresValidationError:
    "The field '{{label}}' was not filled in correctly. It needs to be the same email adress as in the field 'Email address'.",

  VerplichtVeldIsNietIngevuldTijdensVerzenden: "A required field is not filled in.",
  VulUwGegevensIn: "Vul uw gegevens in",
  SchengenFormulier: "Mijn ingevulde en ondertekende medicijnverklaring digitaal opsturen",
  WelkeVerklaringKanIkDigitaalOpsturen: "Welke verklaring kan ik digitaal opsturen?",
  WanneerOntvangIkDeGoedgekeurdeVerklaring: "Wanneer ontvang ik de goedgekeurde verklaring?",
  ValtUwMedicijnOnderDeNederlandseOpiumwet: "Valt uw medicijn onder de Nederlandse opiumwet?",
  VertrekDatum: "Vertrekdatum (dd-mm-jjjj)",
  Voorletters: "Voorletter(s)",
  VolgendLand: "Volgend land",
  Achternaam: "Achternaam",
  Telefoonnummer: "Telefoonnummer",
  Opmerking: "Opmerking",
  BevestigingEmail: "Wilt u een bevestiging op uw e-mailadres ontvangen?",
  Vraag: "Question",
  NaarOnzeHomepage: "Go to our homepage",
  BijlageInfoText:
    "Maximum of {{maxAmount}} attachment(s), maximum of {{maxSizeInMB}} MB per attachment. Allowed extensions: {{extensions}}.",
  AnderLand: "Other country",
  Inleiding: "Introduction"
};
